import { useEffect } from "react";
import { connect } from "react-redux";

const LoginPopupPage = (props) => {
  function closePage() {
    if (
      navigator.userAgent.indexOf("Firefox") != -1 ||
      navigator.userAgent.indexOf("Chrome") != -1
    ) {
      window.location.href = "about:blank";
      window.close();
    } else {
      window.opener = null;
      window.open("", "_self");
      window.close();
    }
  }

  useEffect(() => {
    closePage();
  }, []);

  return null;
};

const stateProps = (state) => {
  return {};
};

const dispatchProps = (dispatch) => ({});

export default connect(stateProps, dispatchProps)(LoginPopupPage);
